<template>
<section class="py-16 bg-gray-50">
  <div class="container mx-auto px-6">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-bold text-gray-800 mb-2">产品定制分类</h2>
      <p class="text-gray-600">选择您想要定制的产品类型，开启个性化之旅</p>
    </div>
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-4">
      <div
        v-for="(category, index) in productCategories"
        :key="index"
        class="bg-white rounded-xl shadow-md overflow-hidden transition-transform duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer"
        @click="goToCustomDetail(category.type)"
      >
        <div class="h-32 md:h-40 overflow-hidden">
          <img :src="category.image" :alt="category.name" class="w-full h-full object-cover object-top">
        </div>
        <div class="p-3 text-center">
          <h3 class="text-base font-semibold text-gray-800 mb-1">{{ category.name }}</h3>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'CategorySection',
  data() {
    return {
      productCategories: [
                {
                    name: "保温杯定制",
                    description: "304不锈钢材质，保温效果好，个性图案随心添加。",
                    type: "保温杯",
                    image: require('@/assets/img/home-dingzhi/保温杯.jpg')
                },
                {
                    name: "T恤定制",
                    description: "多种面料可选，印花、刺绣等工艺，打造专属服装。",
                    type: "T恤",
                    image: require('@/assets/img/home-dingzhi/T恤衫.jpg')
                },
                {
                    name: "丝巾定制",
                    description: "优质棉料，舒适保暖，时尚个性设计。",
                    type: "丝巾",
                    image: require('@/assets/img/home-dingzhi/丝巾.jpg')
                },
                {
                    name: "帆布袋定制",
                    description: "环保材质，耐用实用，个性图案展示您的态度。",
                    type: "帆布袋",
                    image: require('@/assets/img/home-dingzhi/帆布袋.jpg')
                },
                {
                    name: "法兰绒毯定制",
                    description: "柔软温暖，高品质面料，个性化图案定制。",
                    type: "法兰绒毯",
                    image: require('@/assets/img/home-dingzhi/法兰绒毯.jpg')
                },
                {
                    name: "马克杯定制",
                    description: "优质陶瓷，多款式可选，打造专属杯具。",
                    type: "马克杯",
                    image: require('@/assets/img/home-dingzhi/马克杯.jpg')
                },
                {
                    name: "抱枕定制",
                    description: "柔软舒适，个性图案，为家居增添温馨氛围。",
                    type: "抱枕",
                    image: require('@/assets/img/home-dingzhi/抱枕.jpg')
                },
                {
                    name: "手机壳定制",
                    description: "时尚设计，个性化图案，保护您的手机。",
                    type: "手机壳",
                    image: require('@/assets/img/home-dingzhi/手机壳.jpg')
                },
                {
                    name: "餐盘定制",
                    description: "时尚设计，个性化图案，保护您的餐盘。",
                    type: "餐盘",
                    image: require('@/assets/img/home-dingzhi/餐盘.jpg')
                },
                {
                    name: "吧唧/冰箱贴定制",
                    description: "时尚设计，个性化图案，保护您的冰箱。",
                    type: "吧唧/冰箱贴",
                    image: require('@/assets/img/home-dingzhi/吧唧.jpg')
                },
                {
                    name: "鼠标垫定制",
                    description: "时尚设计，个性化图案，保护您的鼠标。",
                    type: "鼠标垫",
                    image: require('@/assets/img/home-dingzhi/鼠标垫.jpg')
                }
            ]
        }
    },
  methods: {
    // goToCustomDetail(tag) {
    //   this.$router.push({ name: 'CategoryList', query: { tag } });
    // },
    goToCustomDetail() {
      this.$router.push({ name: 'CategoryList' });
    }
  }
}
</script> 